import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "user-import-comp" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Use this tool to add or update a batch of users from a CSV.", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Select File "),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-question" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Select CSV file")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Field Mapping "),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-question" })
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", null, "Available CSV Fields", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "You'll be able to map your fields once you select a CSV!", -1)
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Upload ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_divider),
    _createVNode("h3", null, [
      _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "dark",
        content: "This is the file that contains the users that you want to import.",
        placement: "right"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_upload, {
      class: "upload-box",
      action: "",
      accept: ".csv",
      multiple: false,
      "on-change": _ctx.fileSelected,
      "on-remove": _ctx.fileRemoved,
      "auto-upload": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["on-change", "on-remove"]),
    _createVNode("h3", null, [
      _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "dark",
        content: "This is your chance to tell us what the fields in your CSV mean.",
        placement: "right"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    (_ctx.selectedFile !== undefined)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", null, [
            _hoisted_7,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                class: "field-tags",
                key: field
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(field), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createVNode(_component_el_form, {
            class: "flex-wrapper",
            model: _ctx.fieldMapForm,
            ref: "formRef",
            rules: _ctx.fieldMapRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "User ID",
                prop: "id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldMapForm.id = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "First Name",
                prop: "first_name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.first_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldMapForm.first_name = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Last Name",
                prop: "last_name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.last_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fieldMapForm.last_name = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Email Address",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldMapForm.email = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Password",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.password,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fieldMapForm.password = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Username",
                prop: "user_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.user_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldMapForm.user_id = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Organization ID",
                prop: "organizations_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.organizations_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.fieldMapForm.organizations_id = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Phone Number",
                prop: "phone_number"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.phone_number,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fieldMapForm.phone_number = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "VAR Organizations",
                prop: "var_orgs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.var_orgs,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.fieldMapForm.var_orgs = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "User Groups",
                prop: "groups"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.groups,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.fieldMapForm.groups = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "field-map-box",
                label: "Is User Terminated",
                prop: "is_terminated"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fieldMapForm.is_terminated,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.fieldMapForm.is_terminated = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Unmapped",
                        value: ''
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCSVFields, (field) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: field,
                          label: field,
                          value: field
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _hoisted_9
        ])),
    _createVNode(_component_el_divider),
    _createVNode("span", _hoisted_10, [
      _createVNode(_component_el_button, {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close'))),
        disabled: _ctx.isUploading
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["disabled"]),
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.submitFile,
        disabled: !_ctx.readyToUpload
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]), [
        [_directive_loading, _ctx.isUploading]
      ])
    ])
  ]))
}